import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';
import { IConversation, IMessage } from 'app/models/ChatAI';

import { uuidv4 } from 'app/utilities/Utilities';
import generateShortId from 'app/utilities/shortIds';

export const selectConversations = (state:RootState) => state[Reducers.AIChat].conversations;
export const selectConversation = (state:RootState) => state[Reducers.AIChat].conversation;
export const selectSkipInitialChatFetch = (state:RootState) => state[Reducers.AIChat].skipInitialChatFetch;
export const selectLastAnimatedMessageId = (state:RootState) => state[Reducers.AIChat].lastAnimatedMessageId;
export const selectSelectedPromptContent = (state:RootState) => state[Reducers.AIChat].selectedPromptContent;

export const selectMessages = createSelector(
  [ selectConversation ],
  ( conversation:IConversation | null ) => {
    if ( !conversation ) return [];
    const messages = conversation.messages || [];
    const result:Map<string, IMessage[]> = new Map();
    for ( let message of messages ){
      const id = message.id || generateShortId();
      const parentId = message.parentId;
      if ( parentId ){
        if ( result.has(parentId) ){
          const getMessages = result.get(parentId);
          result.set(parentId, [...(getMessages || []), message]);
        }
      } else {
        result.set(id, [message]);
      }
    }
    return Array.from(result).map(([ ,value ]:[ string, IMessage[] ]) => value);
  }
);

export const selectLastHumanMessage = createSelector(
  [ selectConversation ],
  ( conversation:IConversation | null ) => {
    if ( !conversation ) return null;
    const messages = conversation.messages || [];
    for ( let i = messages.length - 1; i >= 0; i-- ){
      const message = messages[i];
      if ( message.type === 'human' ) return message;
    }
    return null;
  }
);











// ToDO: Should be removed
export const selectLoading = (state:RootState) => state[Reducers.AIChat].loading;
export const selectLoadingMessage = (state:RootState) => state[Reducers.AIChat].loadingMessage;
export const selectStatusMessage = (state:RootState) => state[Reducers.AIChat].statusMessage;

export const selectRefineParentId = (state:RootState) => state[Reducers.AIChat].refineParentId;
// export const selectDisableGetConversation = (state:RootState) => state[Reducers.AIChat].disableGetConversation;

export const selectConversationMessagesArray = createSelector(
  [ selectConversation ],
  ( conversation:IConversation | null ) => {
    if ( !conversation ) return null;
    const messages = conversation.messages || [];
    const result:Map<string, IMessage[]> = new Map();
    for ( let message of messages ){
      const id = message.id || uuidv4();
      const parentId = message.parentId;
      if ( parentId ){
        if ( result.has(parentId) ){
          const getMessages = result.get(parentId);
          result.set(parentId, [...(getMessages || []), message]);
        }
      } else {
        result.set(id, [message]);
      }
    }
    return Array.from(result).map(([ ,value ]:[ string, IMessage[] ]) => value);
  }
);
